<script setup lang="ts">
import { AppStars } from '@libs/ui';

import type { ActivityDetailsHeaderData } from '../models';

interface ActivityDetailsHeaderProps {
  headerData: ActivityDetailsHeaderData;
}

const props = defineProps<ActivityDetailsHeaderProps>();
</script>

<template>
  <header class="activity-details-header">
    <div class="header-text">{{ props.headerData.headerText }}</div>
    <div class="subheader">
      <div v-if="props.headerData.subHeaderText" class="subheader-text">
        {{ props.headerData.subHeaderText }}
      </div>
    </div>
    <AppStars :amount="props.headerData.starsAmount" size="24" />
  </header>
</template>

<style scoped lang="scss">
.activity-details-header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: var(--spacing-8);
  padding-bottom: var(--spacing-16);

  .header-text {
    color: var(--color-neutral-70);
    @include font-heading-3;

    @include for-less-or-equal-than-599-px {
      @include font-heading-5;
    }
  }

  .subheader {
    display: flex;
    gap: var(--spacing-8);
    align-items: center;

    .subheader-text {
      color: var(--color-neutral-70);
      @include font-preamble-2;
    }
  }
}
</style>
